import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, QueryList, AfterViewInit  } from '@angular/core';
import { Product } from '../../../models/product';
import { ElementDef } from '@angular/core/src/view';

@Component({
  selector: 'alg-generic-card',
  templateUrl: './alg-generic-card.component.html',
  styleUrls: ['./alg-generic-card.component.scss']
})
export class AlgGenericCardComponent implements OnInit {
  @Input() title: string;
  @Input() cornerIcon: boolean;
  @Input() product: Product;
  @ViewChildren('bordercurve') private bordercurve: QueryList<ElementRef>;
  

  constructor() { }

  ngOnInit() {

  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
    if (isIE) {
      this.bordercurve.toArray().forEach(e => {
        e.nativeElement.style.display = 'none';
      });
     }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-generic-card/alg-generic-card.component.ts